import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLock, FiCreditCard, FiArrowRight, FiShield } from 'react-icons/fi';
import { Button } from './ui/button';

export const InactiveSubscriptionCard = ({ moduleName = 'Dashboard' }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-140px)] p-4 sm:p-6">
      <div className="bg-white dark:bg-slate-900 border border-amber-500/30 rounded-3xl p-8 sm:p-10 max-w-lg w-full text-center shadow-2xl relative overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-amber-500 via-orange-500 to-yellow-400" />
        
        <div className="w-16 h-16 rounded-2xl bg-amber-500/10 text-amber-600 dark:text-amber-400 flex items-center justify-center mx-auto mb-4 border border-amber-500/20 shadow-inner">
          <FiLock size={30} />
        </div>

        <span className="inline-flex items-center gap-1.5 text-[11px] font-extrabold uppercase px-3 py-1 rounded-full bg-amber-500/15 text-amber-600 dark:text-amber-300 border border-amber-500/30 tracking-wider mb-2">
          <FiShield size={12} />
          Assinatura Inativa
        </span>

        <h2 className="text-2xl font-black text-slate-900 dark:text-white mt-2 mb-2">
          {moduleName} Bloqueado
        </h2>

        <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed mb-6">
          Seu período de assinatura expirou. As métricas, relatórios e lançamentos deste módulo estão temporariamente ocultos até a renovação da sua assinatura.
        </p>

        <div className="flex flex-col gap-3">
          <Button
            onClick={() => navigate('/assinatura')}
            className="w-full bg-gradient-to-r from-blue-900 via-blue-800 to-cyan-700 hover:from-blue-800 hover:to-cyan-600 text-white font-bold rounded-xl h-11 shadow-lg shadow-blue-900/20 gap-2 text-sm cursor-pointer"
          >
            <FiCreditCard size={17} />
            Ir para Assinatura e Renovar
            <FiArrowRight size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InactiveSubscriptionCard;
